import _defineProperty from "@babel/runtime/helpers/defineProperty";
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import { css } from '@emotion/react';
import { AnnotationSharedClassNames } from '@atlaskit/editor-common/styles';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var annotationStyles = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.ProseMirror': _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ".".concat(AnnotationSharedClassNames.blur, ", .").concat(AnnotationSharedClassNames.focus, ", .").concat(AnnotationSharedClassNames.draft, ", .").concat(AnnotationSharedClassNames.hover), {
    borderBottom: '2px solid transparent',
    cursor: 'pointer',
    padding: '1px 0 2px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has(.card), &:has([data-inline-card])': {
      padding: '5px 0 3px 0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has(.date-lozenger-container)': {
      paddingTop: "var(--ds-space-025, 2px)"
    }
  }), ".".concat(AnnotationSharedClassNames.focus), {
    background: "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)",
    borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
    boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"
  }), ".".concat(AnnotationSharedClassNames.draft), {
    background: "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)",
    borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
    boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)",
    cursor: 'initial'
  }), ".".concat(AnnotationSharedClassNames.blur), {
    background: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
    borderBottomColor: "var(--ds-border-accent-yellow, #B38600)"
  }), ".".concat(AnnotationSharedClassNames.hover), {
    background: "var(--ds-background-accent-yellow-subtlest-hovered, #F8E6A0)",
    borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
    boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"
  })
});